/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import GridStyles from '@userzoom-themes/peach/components/grid';
import ButtonStyles from '@userzoom-themes/peach/components/button';
import CardStyles from '@userzoom-themes/peach/components/card';
import DialogStyles from '@userzoom-themes/peach/components/dialog';
import SpinnerStyles from '@userzoom-themes/peach/components/spinner';
import TooltipStyles from '@userzoom-themes/peach/components/tooltip';

const themeComponents = {
  ...GridStyles,
  ...ButtonStyles,
  ...CardStyles,
  ...DialogStyles,
  ...SpinnerStyles,
  ...TooltipStyles,
};

export default themeComponents;
